"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaporwearExperience = void 0;
require("@babylonjs/loaders");
require("@babylonjs/gui");
const core_1 = require("@babylonjs/core");
const showroom_1 = require("./showroom");
class VaporwearExperience {
    constructor(showroom) {
        this._showroom = showroom;
    }
    static CreateAsync(params) {
        return __awaiter(this, void 0, void 0, function* () {
            core_1.SceneLoader.OnPluginActivatedObservable.add((plugin) => {
                if (plugin.name === "gltf") {
                    const loader = plugin;
                    loader.transparencyAsCoverage = true;
                }
            });
            const canvas = params.canvas;
            const engine = new core_1.Engine(canvas, undefined, {
                forceSRGBBufferSupportState: true
            });
            window.addEventListener("resize", () => {
                engine.resize();
            });
            const showroom = yield showroom_1.Showroom.CreateAsync(engine, params);
            engine.runRenderLoop(() => {
                showroom.render();
            });
            return new VaporwearExperience(showroom);
        });
    }
    setZoom(zoomPercent) {
        this._showroom.setZoomPercent(zoomPercent);
    }
    disableMouseWheel() {
        this._showroom.disableMouseWheel();
    }
    setCameraBehavior(behavior) {
        switch (behavior) {
            case "overall":
                this._showroom.state = showroom_1.ShowroomState.Overall;
                break;
            case "clasp":
                this._showroom.state = showroom_1.ShowroomState.Clasp;
                break;
            case "face":
                this._showroom.state = showroom_1.ShowroomState.Face;
                break;
            case "levitate":
                this._showroom.state = showroom_1.ShowroomState.Levitate;
                break;
            case "configure":
                this._showroom.state = showroom_1.ShowroomState.Configure;
                break;
        }
    }
    setBandMaterial(materialName) {
        this._showroom.setMeshMaterialByName("chassis", materialName);
    }
    setGlassMaterial(materialName) {
        this._showroom.setMeshMaterialByName("glass", materialName);
    }
    setJewelry(jewelryName) {
        switch (jewelryName) {
            case "none":
                this._showroom.showStuds = false;
                break;
            case "studs":
                this._showroom.showStuds = true;
                break;
        }
    }
    setGemMaterial(materialName) {
        this._showroom.setMeshMaterialByName("diamond", materialName);
    }
    setSettingMaterial(materialName) {
        this._showroom.setMeshMaterialByName("setting", materialName);
    }
    createDebugUI() {
        this._showroom.createDebugtUI();
    }
    addEventListener(event, callback) {
        switch (event) {
            case "hotspotUpdate":
                this._showroom.onHotspotUpdatedObservable.add((hotspotUpdate) => {
                    callback(hotspotUpdate);
                });
                break;
            case "configurationOptionsLoaded":
                if (this._showroom.configurationOptionsLoaded) {
                    callback();
                }
                else {
                    this._showroom.configurationOptionsLoadedObservable.addOnce(() => {
                        callback();
                    });
                }
        }
    }
}
exports.VaporwearExperience = VaporwearExperience;
